/**
 * CONTACT
 */
 'use strict';
 import '@/_constant/global';
 import pageContact from '@/_page/pageContact';
 
 document.addEventListener('DOMContentLoaded', () => {
   gTOCO.mods['contact'] = new pageContact();
 }, false);
 
 window.addEventListener('load', () => {
   gTOCO.mods['contact'].start();
 }, false);
 
 window.addEventListener('unload', () => {}, false);
 